import React from "react";
import get from "lodash/get";
import { object, string } from "prop-types";

import { getddMMyyyy, gethhmm } from "../../../helper/date-utils";

import "./key-events.m.css";

const getEvents = (cards = []) => {
  return cards
    .filter((card) => get(card, ["metadata", "attributes", "key-event"], false))
    .map((card) => {
      const titleElement = card["story-elements"].find(({ type }) => type === "title");

      if (titleElement) {
        return {
          ...titleElement,
          "card-id": card.id,
          "card-added-at": card["card-added-at"],
        };
      }
    });
};

const KeyEvents = ({ story, displayOrder }) => {
  const events = getEvents(story.cards);

  if (!events.length) return null;

  return (
    <div styleName="wrapper">
      <div styleName="event-title">KEY EVENTS</div>
      <div styleName="events">
        <ul styleName={`events-list ${displayOrder === "old" ? "reverse" : ""}`}>
          {events.map((event) => {
            return (
              <li key={event["card-id"]}>
                <a href={`#live-blog-card-${event["card-id"]}`}>
                  <h3 styleName="event-date">
                    {`${gethhmm(event["card-added-at"])}, ${getddMMyyyy(event["card-added-at"]).slice(0, -6)}`}
                  </h3>
                  <span styleName="event-content">{event.text}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

KeyEvents.propTypes = {
  story: object,
  displayOrder: string,
};

export default KeyEvents;
